import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { parseURL, BackButton, hasPermission } from '../../sc-utilities';
import { updateURL } from '../../sc-utilities';
import { Paper, Tabs, Tab, withStyles, Typography, CircularProgress, Box } from '@material-ui/core';
import TransportColliDetails from './TransportColliDetails';
import MediaGallery from '../../sc-media/MediaGallery';
import { getMediaArrays } from '../../sc-media/utilities';
import { CancelToken } from 'axios';
import * as action from '../../np-core/Auth/store/authActions';
import * as actionTransport from '../TransportColli/store/transportColliActions';
import * as groupActions from "../../sc-group/Group/store/groupActions";


const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(5),
        paddingTop: theme.spacing(),
        marginBottom: theme.spacing(-0.75),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    }
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={props.style}>
            {props.children}
        </Typography>
    );
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

const DetailsPalettesTab = props => {
    const { classes, theme, saveColumnsFilter, activeCustomer, externalLoading, onUnpairedExternal, onUnpairedBulkExternal, onClearStateTransport, permissions, loadingTransport, translations, onListOrders, activeExternalServiceAvailable, transportStorage, onFetchTransportColli, onEditTransportColli, fetchGroups } = props;
    const [tabValue, setTabValue] = useState(getTabValue());
    const searchParams = parseURL(window.location.href);

    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mediaArrays, setMediaArrays] = useState({ videoArray: [], audioArray: [], imageArray: [] });
    const [deletedMedia, setDeletedMedia] = useState(false);
    const [groups, setGroups] = useState(null);

    useEffect(() => {
        const requestToken = CancelToken.source();
        const requestTokenOrder = CancelToken.source();

        const fetchData = async () => {
            if (!loadingTransport) {
                await onFetchTransportColli({ TransportColliID: searchParams.TransportColli, ActiveCustomerID: activeCustomer }, { cancelToken: requestToken.token })
                let data = await onListOrders({
                    ActiveCustomerID: activeCustomer,
                    q: { Status: ["new", "scheduled", "in_warehouse", "on_hold"] }
                }, { cancelToken: requestTokenOrder.token });
                data = data.length > 0 ? data : [{ value: "none", displayValue: "None" }];
                setOrders(data);
            }
            setLoading(true)
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            requestTokenOrder.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomer, loadingTransport, externalLoading, onClearStateTransport, deletedMedia]);

    useEffect(() => {
        if (transportStorage && transportStorage.Media && transportStorage.Media.length > 0) {
            const media = getMediaArrays(transportStorage.Media);
            setMediaArrays({ imageArray: media.tempImages, videoArray: media.tempVideos, audioArray: media.tempAudio });
        }
    }, [transportStorage]);

    useEffect(() => {
        const getGroups = async () => {
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomer });
            if (resultGroups) {
                let groupsToSet = resultGroups.data.map(group => ({ value: group.GroupID, displayValue: group.Name }));
                if (hasPermission(permissions, 'access_all_transport_collies_on_customer')) {
                    groupsToSet = [...groupsToSet, { value: 'n/a', displayValue: 'n/a' }];
                }
                setGroups(groupsToSet);
            }
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
    }, [fetchGroups, activeCustomer, permissions]);

    const handleChange = (_event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    return (
        <>
            <Paper className={classes.root}>
                {BackButton(translations)}
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    {hasPermission(permissions, 'transport_colli_load') ? <Tab label={translations['details'] || "Details"} /> : null}
                    {hasPermission(permissions, 'transport_colli_load') ? <Tab label={translations['media'] || "Media"} /> : null}

                </Tabs>
            </Paper>


            {hasPermission(permissions, 'transport_colli_load') ?
                <TabPanel index={0} value={tabValue} style={{ padding: 3 * 3 }}>
                    <TabContainer dir={theme.direction}>
                        {transportStorage !== null ? <TransportColliDetails onUnpairedExternal={onUnpairedExternal} onUnpairedBulkExternal={onUnpairedBulkExternal} loadingTransport={loadingTransport} translations={translations} saveColumnsFilter={saveColumnsFilter} loading={loading} orders={orders} onEditPalette={onEditTransportColli} activeExternalServiceAvailable={activeExternalServiceAvailable} permissions={permissions} activeCustomerID={activeCustomer} palette={transportStorage} groups={groups} />
                            : <CircularProgress size={50} />}</TabContainer> </TabPanel> : null}
            {hasPermission(permissions, 'transport_colli_load') ? <TabPanel style={{ padding: 3 * 3, paddingTop: '25px' }} index={1} value={tabValue}> <TabContainer dir={theme.direction}><MediaGallery transportColliID={searchParams.TransportColli} onRefresh={() => setDeletedMedia(!deletedMedia)} entity={translations['transport_colli'] || 'Transport Colli'} translations={translations} images={mediaArrays.imageArray} videos={mediaArrays.videoArray} audio={mediaArrays.audioArray} permissions={permissions} /></TabContainer> </TabPanel> : null}
        </>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        transportStorage: state.palette.transportCollies.loaded,
        loadingTransport: state.palette.transportCollies.editing,
        externalLoading: state.palette.transportCollies.external,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUnpairedBulkExternal: (data, options) => dispatch(actionTransport.unpairedBulkExternalTransportColli(data, options)),
        onUnpairedExternal: (data, options) => dispatch(actionTransport.unpairedExternalTransportColli(data, options)),
        onFetchTransportColli: (data, options) => dispatch(actionTransport.loadTransportColli(data, options)),
        onEditTransportColli: transportColli => dispatch(actionTransport.editTransportColli(transportColli)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onClearStateTransport: () => dispatch(actionTransport.ClearState()),
        onListOrders: (data, options) => dispatch(actionTransport.listOrders(data, options)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(DetailsPalettesTab));